import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';

export default function AboutPage() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="pt-16">
        <section className="py-10 md:py-14 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-8" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-500 transition-colors whitespace-nowrap">首页</Link>
              <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center"></i>
              <span className="text-foreground-950 font-medium">关于我们</span>
            </nav>

            <div className="text-center mb-12">
              <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
                关于樱花漫画
              </h1>
              <p className="text-foreground-500 max-w-2xl mx-auto leading-relaxed">
                樱花漫画致力于打造最优质的免费漫画阅读平台，让每一位漫画爱好者都能轻松享受阅读的乐趣
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-14">
              <div className="p-6 rounded-lg bg-background-100 text-center">
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-book-open-line text-2xl text-primary-500"></i>
                </div>
                <h3 className="font-heading text-lg font-bold text-foreground-950 mb-2">海量资源</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  收录超过20,000部漫画资源，涵盖日漫、韩漫、国漫等热门类型，总有你爱看的那一部。
                </p>
              </div>
              <div className="p-6 rounded-lg bg-background-100 text-center">
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-download-cloud-2-line text-2xl text-accent-500"></i>
                </div>
                <h3 className="font-heading text-lg font-bold text-foreground-950 mb-2">离线下载</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  支持漫画章节离线下载，无网络也能畅快阅读。随时随地享受漫画带来的快乐时光。
                </p>
              </div>
              <div className="p-6 rounded-lg bg-background-100 text-center">
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-secondary-100">
                  <i className="ri-rocket-line text-2xl text-secondary-500"></i>
                </div>
                <h3 className="font-heading text-lg font-bold text-foreground-950 mb-2">极速更新</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  与各大平台同步更新，热门连载漫画24小时内上线，让你永远快人一步追到最新内容。
                </p>
              </div>
            </div>

            <div className="mb-14">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-1 h-5 bg-primary-500 rounded-full"></div>
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">品牌故事</h2>
              </div>
              <div className="prose prose-sm max-w-none text-foreground-600 leading-relaxed space-y-4">
                <p>
                  樱花漫画成立于2020年，由一群热爱漫画的年轻人共同创建。我们深信漫画不仅仅是一种娱乐方式，更是一种跨越语言和国界的艺术表达。无论是日漫的细腻情感、韩漫的唯美画风，还是国漫的磅礴气势，每一种漫画都有其独特的魅力。
                </p>
                <p>
                  从最初的小众网站到如今拥有数百万读者的漫画平台，樱花漫画始终坚持「免费、完整、高品质」的核心理念。我们不仅提供漫画在线阅读，还支持离线下载功能，让读者在没有网络的环境下也能畅享漫画世界。
                </p>
                <p>
                  我们的团队不断优化阅读体验，从高清画质到流畅翻页，从个性化推荐到智能搜索，每一个细节都倾注了我们的心血。未来，樱花漫画将继续拓展漫画资源库，探索更多可能性，为漫画爱好者打造一个真正属于他们的精神家园。
                </p>
              </div>
            </div>

            <div className="mb-14">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-1 h-5 bg-accent-500 rounded-full"></div>
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">读者口碑</h2>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {[
                  { name: '小明同学', text: '樱花漫画真的是我用过最好用的漫画平台！资源多更新快，离线下载功能太实用了，坐地铁也能看。强烈推荐！', rating: 5 },
                  { name: '漫画控阿星', text: '日漫韩漫国漫全都有，画质也很清晰。收藏追更功能特别方便，追的漫画一更新就有提醒，再也不会忘记看到哪了。', rating: 5 },
                  { name: '二次元小樱', text: '已经用了三年多了，看着平台越来越好。免费全集真的良心，不需要付费就能看到完整内容，感谢樱花漫画！', rating: 5 },
                  { name: '追漫达人老王', text: '分类很细致，找漫画很方便。24小时同步更新这点真的赞，热门漫画基本当天就能看到最新话，五星好评！', rating: 4 },
                ].map((review, i) => (
                  <div key={i} className="p-5 rounded-lg bg-background-100">
                    <div className="flex items-center gap-1 mb-2">
                      {Array.from({ length: 5 }, (_, j) => (
                        <i
                          key={j}
                          className={`text-sm w-3.5 h-3.5 flex items-center justify-center ${
                            j < review.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'
                          }`}
                        ></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-3">{review.text}</p>
                    <p className="text-xs text-foreground-400 font-medium">{review.name}</p>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <div className="flex items-center gap-3 mb-6">
                <div className="w-1 h-5 bg-secondary-500 rounded-full"></div>
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">联系我们</h2>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
                <div className="p-5 rounded-lg bg-background-100 flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 flex-shrink-0">
                    <i className="ri-mail-line text-lg text-primary-500"></i>
                  </div>
                  <div>
                    <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-1">电子邮箱</h4>
                    <p className="text-sm text-foreground-500">contact@yinghuamanhua.com</p>
                  </div>
                </div>
                <div className="p-5 rounded-lg bg-background-100 flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 flex-shrink-0">
                    <i className="ri-customer-service-2-line text-lg text-accent-500"></i>
                  </div>
                  <div>
                    <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-1">在线客服</h4>
                    <p className="text-sm text-foreground-500">工作日 9:00 - 18:00</p>
                  </div>
                </div>
                <div className="p-5 rounded-lg bg-background-100 flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 flex-shrink-0">
                    <i className="ri-map-pin-line text-lg text-secondary-500"></i>
                  </div>
                  <div>
                    <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-1">公司地址</h4>
                    <p className="text-sm text-foreground-500">上海市浦东新区张江高科技园区</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}